<div>
    <h6 class="newharder">
        <span>{{'CHRONIC' | translate}} </span>
        <i *ngIf="editableContent || addNewChronic" (click)="newChronic();" class="fa fa-plus fa-1x"></i>
    </h6>
    <div class="container-fluid border">
        <div class="my-2">
            <form *ngIf="editableContent || addNewChronic" novalidate [formGroup]="chronicForm">
                <div class="col">
                    <div class="insidbf position-relative">
                        <div>
                            <div class="row">
                                <div class="col-4">
                                    <label for="historyText">{{'Name' | translate}}</label>
                                    <sanabel-selectize [appcode]="1221" [addNewItem]="1" formControlName="historycode"
                                        [simpleView]="true">
                                    </sanabel-selectize>
                                </div>
                                <div class="col-4">
                                    <label for="startDate">{{ 'StartDate' | translate }}</label>
                                    <div class="input-group">
                                        <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                                            ngbDatepicker #dp="ngbDatepicker" formControlName="startDate">
                                        <div class="input-group-addon" (click)="dp.toggle()">
                                            <i class="fa fa-calendar-minus-o"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <label for="endDate">{{ 'ENDDATE' | translate }}</label>
                                    <div class="input-group">
                                        <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                                            ngbDatepicker #dpo="ngbDatepicker" formControlName="endDate">
                                        <div class="input-group-addon" (click)="dpo.toggle()">
                                            <i class="fa fa-calendar-minus-o"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <label for="notes">{{'NOTES' | translate}}</label>
                                    <input formControlName="notes" class="form-control form-control-sm" type="text">
                                </div>
                                <div class="col-4">
                                    <label for="family">{{'FAMILY' | translate}}</label>
                                    <sanabel-selectize [appcode]="246" formControlName="family" [simpleView]="true">
                                    </sanabel-selectize>
                                </div>
                                <div class="col-4">
                                    <label for="past">{{'PAST' | translate}}</label>
                                    <sanabel-selectize [appcode]="248" formControlName="past" [simpleView]="true">
                                    </sanabel-selectize>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div [hidden]="addNewChronic==true" class="row mt-2">
                    <div class="col text-center">
                        <btns-ctrl (clicked)="onClicked($event, null)" [appCodes]="[1]"></btns-ctrl>
                    </div>
                </div>
            </form>
            <div class="p-0">
                <table class="table table-bordered table-striped">
                    <thead class="ui-datatable-thead">
                        <tr>
                            <th style="width:20%;">{{ 'Name' | translate }}</th>
                            <th style="width:10%;">{{ 'StartDate' | translate }}</th>
                            <th style="width:10%;">{{ 'ENDDATE' | translate }}</th>
                            <th style="width:15%;">{{ 'NOTES' | translate }}</th>
                            <th style="width:10%;">{{ 'USERNAME' | translate }}</th>
                            <th *ngIf="editableContent" style="width:5%;">{{ 'SETTING' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody class="ui-datatable-data ui-widget-content">
                        <tr class="ui-widget-content" *ngFor="let item of emrChronicData; index as indx"
                            [ngClass]="{'deleted-row':item.deleteStatus}">
                            <td>
                                {{ translate.currentLang == 'ar' ? item.nameAr : item.nameEn }}
                            </td>
                            <td>
                                {{ item.startDate | date:'mediumDate' }}
                            </td>
                            <td>
                                {{ item.endDate | date:'mediumDate' }}
                            </td>
                            <td>
                                {{ item.notes }}
                            </td>
                            <td>
                                <span *ngIf="item.userID == _docId">{{ item.userName }}</span>
                                <span class="text-danger" *ngIf="item.userID != _docId">{{ item.userName }}</span>
                            </td>
                            <td *ngIf="editableContent">
                                <icon-action (clicked)="onClicked($event, item)" [appCodes]="[402,403]"></icon-action>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>